<div class="modal-header">
  <h4 class="modal-title">Select Date Range for Export</h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p class="text-muted mb-2">You can select a date range up to 1 year for export.</p>
  <div class="export-daterange-container">
    <input type="text" ngxDaterangepickerMd
      [locale]="{format: 'DD-MM-YYYY', direction: 'ltr'}"
      [(ngModel)]="selectedDates"
      class="form-control"
      [maxDate]="maxDate"
      [dateLimit]="365"
      [showDropdowns]="true"
      [lockStartDate]="false"
      [linkedCalendars]="false"
      [customRangeDirection]="false"
      [autoApply]="true"
      (ngModelChange)="onDateRangeChange($event)"
      placeholder="Select date range"
      readonly
    />
    <span class="ngx-daterangepicker-action" style="margin-left: -8px; padding-top: 12px; cursor: pointer;">
      <mat-icon class="ngx-daterangepicker-action" aria-hidden="false" aria-label="Calendar icon"
        color="primary" [inline]="false">today</mat-icon>
    </span>
  </div>
  <div *ngIf="hasError" class="text-danger mt-2">
    Please select a date range.
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Cancel')">
    Cancel
  </button>
  <button type="button" class="btn btn-primary" (click)="onExport()">
    Export
  </button>
</div>
